import {
  deleteData,
  getData,
  getDataforUrl,
  postFormData,
  putFormData,
  postRawData
} from "./index";

// Plans API
export const plansList = async (payload) => {
  return getData("subscription/plans", payload).then((data) => {
    return data;
  });
};

export const getPlanDetails = async (payload) => {
  return getDataforUrl("subscription/plans", payload).then((data) => {
    return data;
  });
};

export const createPlan = async (payload) => {
  return postFormData("subscription/plans", payload).then((data) => {
    return data;
  });
};

export const updatePlan = async (id, payload) => {
  return putFormData(`subscription/plans/${id}`, payload).then((data) => {
    return data;
  });
};

export const deletePlan = async (id) => {
  return deleteData(`subscription/plans/${id}`, {}).then((data) => {
    return data;
  });
};

// Addons API
export const addonsList = async (payload) => {
  return getData("subscription/addons", payload).then((data) => {
    return data;
  });
};

export const getAddonDetails = async (payload) => {
  return getDataforUrl("subscription/addons", payload).then((data) => {
    return data;
  });
};

export const createAddon = async (payload) => {
  return postFormData("subscription/addons", payload).then((data) => {
    return data;
  });
};

export const updateAddon = async (id, payload) => {
  return putFormData(`subscription/addons/${id}`, payload).then((data) => {
    return data;
  });
};

export const deleteAddon = async (id) => {
  return deleteData(`subscription/addons/${id}`, {}).then((data) => {
    return data;
  });
};

// Subscription Purchase API
export const createCheckoutSession = async (payload) => {
  return postRawData("subscription/create-checkout-session", payload).then((data) => {
    return data;
  });
};

export const handleSubscriptionSuccess = async (payload) => {
  return postRawData("subscription/subscription-success", payload).then((data) => {
    return data;
  });
};

export const getCompanySubscription = async (companyId) => {
  return getData(`subscription/company-subscription/${companyId}`, {}).then((data) => {
    return data;
  });
};

export const updateSubscriptionAddons = async (payload) => {
  return postRawData("subscription/update-subscription-addons", payload).then((data) => {
    return data;
  });
};

export const updateSubscriptionPlan = async (payload) => {
  return postRawData("subscription/update-subscription-plan", payload).then((data) => {
    return data;
  });
};

export const getAllCompanySubscriptions = async (companyId) => {
  return getData(`subscription/company-subscriptions/${companyId}`, {}).then((data) => {
    return data;
  });
};

export const extendTrialPeriod = async (payload) => {
  return postRawData("subscription/extend-trial", payload).then((data) => {
    return data;
  });
};
